export const READ_CONTENT_REQUEST = 'content/READ_CONTENT_REQUEST';
export const READ_CONTENT_SUCCESS = 'content/READ_CONTENT_SUCCESS';
export const READ_CONTENT_FAILURE = 'content/READ_CONTENT_FAILURE';

export const READ_CONTENTS_REQUEST = 'content/READ_CONTENTS_REQUEST';
export const READ_CONTENTS_SUCCESS = 'content/READ_CONTENTS_SUCCESS';
export const READ_CONTENTS_FAILURE = 'content/READ_CONTENTS_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/content/content.actionTypes.js